import React from 'react';

import Image from '../../Commons/Image/Image';
import RECOLETA from '../../../assets/swiss-medical-center/centro_recoleta.jpg';

import styles from './SwissMedicalRecoleta.module.scss';

const SwissMedicalRecoleta = () => {
  return (
    <div className={styles.swiss_medical_recoleta}>
      <h3>Recoleta</h3>
      <p>
        <strong className={styles.swiss_medical_recoleta__redText}>Dirección:</strong> Junín 1191,
        Capital Federal
      </p>
      <p>
        <strong className={styles.swiss_medical_recoleta__redText}>Turnos:</strong> 0810-333-8876
      </p>
      <Image
        src={RECOLETA}
        alt='Sede Recoleta'
        title='Recoleta'
        classes={styles.swiss_medical_recoleta__image}
      />
      <p>
        <strong className={styles.swiss_medical_recoleta__redText}>Atención Programada</strong>
      </p>
      <p className={styles.swiss_medical_recoleta__redText}>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p className={styles.swiss_medical_recoleta__redText}>Sábados | 08 hs. a 14 hs.</p>
      <ul>
        <li>Pediatría</li>
        <li>Dermatología pediátrica</li>
        <li>Otorrinolaringología pediátrica</li>
        <li>Ginecología infanto-juvenil</li>
        <li>Cirugía plástica reparadora pediátrica</li>
        <li>Cirugía general pediátrica</li>
        <li>Adolescencia</li>
        <li>Cardiología pediátrica</li>
        <li>Nutrición pediátrica</li>
      </ul>
      <p>
        <strong className={styles.swiss_medical_recoleta__redText}>Servicios de Diagnóstico</strong>
      </p>
      <ul>
        <li>Ecografía mamaria</li>
        <li>Mamografía</li>
        <li>Ecografía pediátrica</li>
        <li>Placas odontológicas</li>
      </ul>
    </div>
  );
};

export default SwissMedicalRecoleta;
